import { PdfExportFormat, PdfExportOptions, PdfExportOrientation } from 'common/hooks/usePdfExport/types';

export interface PdfExportConfigDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm?: (options: PdfExportOptions) => void;
  initialOptions?: Partial<PdfExportOptions>;
  urls?: string[];
}

export interface PdfExportConfigDialogState {
  scale?: number;
  backgroundColor?: string;
  format?: PdfExportFormat;
  orientation?: PdfExportOrientation;
  quality?: number;
  width?: number;
  height?: number;
}

// PDF Export Options
export enum PdfExportOption {
  VALUATIONS = 'valuations',
  OTHER = 'other',
  FUND = 'fund',
  FIRM = 'firm',
}

// Company sub-options
export interface CompanyPdfOptions {
  summary: boolean;
  financials: boolean;
  fundOwnership: boolean;
  capTable: boolean;
  breakpointAnalysis: boolean;
  valuations: boolean;
  waterfall: boolean;
}

// Fund sub-options
export interface FundPdfOptions {
  summary: boolean;
  scheduleOfInvestments: boolean;
}

// Firm sub-options
export interface FirmPdfOptions {
  summary: boolean;
}

// Main PDF export configuration
export interface PdfExportConfiguration {
  selectedOption: PdfExportOption;
  companyOptions: CompanyPdfOptions;
  fundOptions: FundPdfOptions;
  firmOptions: FirmPdfOptions;
}

// Default configurations
export const DEFAULT_COMPANY_OPTIONS: CompanyPdfOptions = {
  summary: true,
  financials: true,
  fundOwnership: true,
  capTable: true,
  breakpointAnalysis: true,
  valuations: true,
  waterfall: true,
};

export const DEFAULT_FUND_OPTIONS: FundPdfOptions = {
  summary: true,
  scheduleOfInvestments: true,
};

export const DEFAULT_FIRM_OPTIONS: FirmPdfOptions = {
  summary: true,
};

export const DEFAULT_PDF_CONFIGURATION: PdfExportConfiguration = {
  selectedOption: PdfExportOption.VALUATIONS,
  companyOptions: DEFAULT_COMPANY_OPTIONS,
  fundOptions: DEFAULT_FUND_OPTIONS,
  firmOptions: DEFAULT_FIRM_OPTIONS,
};